import React, { FunctionComponent } from 'react';

import cx from 'clsx';

import styles from './ResponsiveImage.module.scss';

type ResponsiveImageUrl = {
  [size: string]: string;
};
type ResponsiveImageProps = {
  imageUrl: string | ResponsiveImageUrl;
  alt: string;
  className?: string;
  imageName?: string;
};
const ResponsiveImage: FunctionComponent<ResponsiveImageProps> = ({ imageUrl, alt, className, imageName }) => {
  if (typeof imageUrl === 'string') {
    return (
      <div className={cx(styles['responsive-image__container'])}>
        <img
          className={cx(styles['responsive-image'], className)}
          src={imageUrl}
          alt={alt}
          data-name={imageName ? imageName : ''}
        />
      </div>
    );
  }

  return (
    <>
      {Object.keys(imageUrl).map((screenSize, index) => (
        <img
          key={index}
          className={cx(className, styles['responsive-image_hidden'], styles[`responsive-image_${screenSize}`])}
          src={imageUrl[screenSize]}
          alt={alt}
        />
      ))}
    </>
  );
};

export default ResponsiveImage;
